import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ish-confirm-leave-modal',
  templateUrl: './confirm-leave-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class ConfirmLeaveModalComponent {
  activeModal = inject(NgbActiveModal);
}
